import { FC, useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { Route, Switch } from 'react-router-dom';
import { history } from 'redux/store';
import LayoutContainer from './components/Layout/LayoutContainer';
import { Error404 } from './pages/Error404';
import { setLocalStorageSeonFingerPrint } from './utils';
import CORE_SETTINGS from './core/settings';
import { DevelopmentInfoContainer } from './components/controls';

const App: FC = () => {
  useEffect(() => {
    const runSeon = async () => {
      if (!window.seon) return;

      try {
        // window.seon.init();

        const session = await window.seon.getSession({
          dnsResolverDomain: 'seondfresolver.com',
        });

        if (session) setLocalStorageSeonFingerPrint(session);
      } catch (error) {
        console.error(error);
      }
    };

    runSeon();
  }, []);

  return (
    <ConnectedRouter history={history}>
      {CORE_SETTINGS.isDevelopStage && <DevelopmentInfoContainer />}

      <Switch>
        <Route path="/" component={LayoutContainer} />
        <Route component={Error404} />
      </Switch>
    </ConnectedRouter>
  );
};

export default App;
